import React, { useEffect, useRef, useState } from 'react'
import CustomFilterDropDown from '../../../ReUsableComponent/CustomFilterDropdown';
import CustomDateRangePicker from '../../../ReUsableComponent/CustomDaterangePicker';
import { userAuthActions } from '../../../store/reducers/UserAuthReducers';
import { GetBrandNameList } from '../../RuleManagement/RuleManagement.service';
import { GetSalesYear } from '../../SalesOverview/SalesOverview.service';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ToastErrorService, ToastSuccessService } from '../../../ReUsableComponent/ToastNotification/ToastService';
import moment from 'moment';
import dropDownIcon from '../../../assets/svg/dropDownIcon.svg';
import CalendarIcon from '../../../assets/svg/calendar_2_fill.svg';
import { stockActions } from '../../../store/reducers/StockOverviewReducer';
import DownloadIcon from '../../../assets/svg/blueDownload.svg';
import CustomTableWithFilter from '../../../ReUsableComponent/CustomTableWithFilter';
import { stockDashboardDetailedTableHeader, stockDashboardTableHeader } from '../../TableHeaders';
import { DownlaodStockReport, GetStockDashboardCardsData, GetStockDashboardData, getStockFilterValue } from '../StockOverview.service';
import Loader from '../../../ReUsableComponent/Loader';
import CustomModal from '../../../ReUsableComponent/CustomModal';
import CloseIcon from '../../../assets/svg/crossIcon.svg';
import { saveAs } from 'file-saver';
import CustomFilterSearchDropdown from '../../../ReUsableComponent/CustomFilterSearchDropdown';
import dayjs from 'dayjs';
import CustomBlueButton from '../../../ReUsableComponent/CustomBlueButton';
import CustomMonthYearPicker from '../../../ReUsableComponent/CustomMonthYearPicker';
import { brandManagementActions } from '../../../store/reducers/BrandManagementReducer';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "80%",
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '40px 32px',
    borderRadius: 6,
    border: '1px solid #3333330D'
};

const StockDashboard = () => {

    const today = new Date();
    today.setDate(1)
    today.setHours(-1)
    const firstDayOfMonth = new Date(today.getFullYear(), (today.getMonth()));
    const gridRef = useRef(null);

    const customDate = useSelector((state) => state.stock.customDate)
    const history = useHistory();
    const dispatch = useDispatch();
    const [calendarOpen, setCalendarOpen] = useState(false);
    const [openStockModal, setOpenStockModal] = useState(false);
    const [openSalesModal, setOpenSalesModal] = useState(false);
    const [openDetailedModal, setOpenDetailedModal] = useState(false);
    const [detailedModalData, setDetailedModalData] = useState({
        heading: '',
        data: [],
    });
    const [loading, setLoading] = useState(false);
    const [brandList, setBrandList] = useState([]);
    const [regionList, setRegionList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [storeList, setStoreList] = useState([]);
    const [salesYearList, setSalesYearList] = useState([]);
    const [anchorElForBrand, setAnchorElForBrand] = useState(null);
    const openBrandFilter = Boolean(anchorElForBrand);
    const [anchorElForRegion, setAnchorElForRegion] = useState(null);
    const openRegionFilter = Boolean(anchorElForRegion);
    const [anchorElForState, setAnchorElForState] = useState(null);
    const openStateFilter = Boolean(anchorElForState);
    const [anchorElForStore, setAnchorElForStore] = useState(null);
    const openStoreFilter = Boolean(anchorElForStore);
    const [anchorElForSales, setAnchorElForSales] = useState(null);
    const openSalesYearFilter = Boolean(anchorElForSales);
    // const [selectedBrand, setSelectedBrand] = useState({ label: '', value: '' });
    const [selectedRegion, setSelectedRegion] = useState({ label: '', value: '' });
    const [selectedState, setSelectedState] = useState({ label: '', value: '' });
    const [selectedStore, setSelectedStore] = useState({ label: '', value: '' });
    const [selectedSalesYear, setSelectedSalesYear] = useState({ label: '', value: '' });
    const [selectedCustomSalesYear, setSelectedCustomSalesYear] = useState(customDate);
    const startDateDisplay = useSelector(state => state.stock.startDateDisplay);
    const endDateDisplay = useSelector(state => state.stock.endDateDisplay);
    const [selectedRange, setSelectedRange] = useState([firstDayOfMonth, today]);
    const [startDate, setStartDate] = useState(useSelector(state => state.stock.startDate));
    const [endDate, setEndDate] = useState(useSelector(state => state.stock.endDate));
    const defaultYear = useSelector(state => state.stock.defaultYear);
    const defaultBrand = useSelector(state => state.brandManagement.selectedBrand);
    const [stockActiveTabBtn, setStockActiveTabBtn] = useState(1);
    const [disabledDateRange, setDisabledDateRange] = useState(true);
    const [saleActiveTabBtn, setSaleActiveTabBtn] = useState(1);
    const [totalStockData, setTotalStockData] = useState([]);
    const [stockDashCardData, setStockDashCardData] = useState({
        "opening_stock": 0,
        "stock_added": 0,
        "stock_sold": 0,
        "remaining_stock": 0,
        "target_month": ""
    });
    const [totalSoldOutData, setTotalSoldOutData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const USER_TOKEN = useSelector((state) => state.userAuthentication.userToken);
    const [dropSearchValue, setdropSearchValue] = React.useState({ brand: '', region: '', state: '', store: '' });
    const USER_ID = useSelector((state) => state.userAuthentication.userId);
    const prevPayload = useRef(null);
    const convertDateIntoMonth = (dateString) => {
        // If it's already in "Month-Year" format, return as is
        if (typeof dateString === 'string' && /^[A-Za-z]+-\d{4}$/.test(dateString)) {
            return dateString;
        }
        
        // Handle null, undefined, or empty
        if (!dateString) {
            return dayjs().format('MMMM-YYYY'); // Or use native Date as fallback
        }
        
        let date = new Date(dateString);
        
        if (isNaN(date.getTime())) {
            return dayjs().format('MMMM-YYYY');
        }
        
        const year = date.getFullYear();
        const month = date.toLocaleString('en-US', { month: 'long' });
        return `${month}-${year}`;
    }
    const val = useSelector(state => state?.stock?.defaultMonthYear);
    const [selectedMonthYear, setSelectedMonthYear] = useState(() => convertDateIntoMonth(val));
    

    const handleSearchChange = (event, name) => {
        if (name === 'brand') setdropSearchValue(prev => ({ ...prev, brand: event.target.value }));
        else if (name === 'region') setdropSearchValue(prev => ({ ...prev, region: event.target.value }));
        else if (name === 'state') setdropSearchValue(prev => ({ ...prev, state: event.target.value }));
        else if (name === 'store') setdropSearchValue(prev => ({ ...prev, store: event.target.value }));
    };

    useEffect(() => {
        dispatch(userAuthActions.setHeaderName({ type: 'Stock Overview' }));
        dispatch(userAuthActions.setIsBackBtnActive({ type: false }));
        getAllBrand();
        getSalesYearList();
    }, [])

    useEffect(() => {
        if (defaultBrand.value) getRegionStateStore(defaultBrand.value, selectedRegion.value, selectedState.value);
    }, [defaultBrand, selectedRegion, selectedState])

    useEffect(async () => {
        const payload = {
            year: selectedMonthYear,
            brand: defaultBrand.value,
            stores: storeList,
            selectedStore: selectedStore.value
        };

        if (JSON.stringify(prevPayload.current) === JSON.stringify(payload)) {
            return; // 🔥 Skip duplicate call
        }

        prevPayload.current = payload;

        // if (storeList.length > 0) {
            const storeIds = getStoreIds();
            if (defaultBrand.value && selectedMonthYear !== '') {
                getDashboardData(selectedMonthYear.replace('-', ' '), defaultBrand.value, '', '', selectedRegion.value, selectedState.value, storeIds);
                getstockDashboardCardData(selectedMonthYear.replace('-', ' '), defaultBrand.value, '', '', selectedRegion.value, selectedState.value, storeIds);
                // } else if (defaultYear.value === '' && startDate && endDate) {
                //     getDashboardData('', defaultBrand.value, startDate, endDate, selectedRegion.value, selectedState.value, selectedStore.value);
                // }
            } 
            // else if (defaultYear.value === '' && selectedCustomSalesYear) {
            //     const range = await formatToMonthYear(selectedCustomSalesYear);
            //     getDashboardData(range, defaultBrand.value, '', '', selectedRegion.value, selectedState.value, storeIds);
            // }
        // }

    }, [selectedMonthYear, defaultBrand, selectedStore])


    const openCalendar = () => {
        setCalendarOpen(prev => !prev)
    }

    const onClickGotoReports = () => {
        history.push('/app/stockOverview');
        dispatch(userAuthActions.setIsBackBtnActive({ type: true }));
    }

    const handleBrandClick = (event) => {
        setAnchorElForBrand(event.currentTarget);
    };
    const handleBrandClose = () => {
        setAnchorElForBrand(null);
    };
    const handleRegionClick = (event) => {
        setAnchorElForRegion(event.currentTarget);
    };
    const handleRegionClose = () => {
        setAnchorElForRegion(null);
    };
    const handleStateClick = (event) => {
        setAnchorElForState(event.currentTarget);
    };
    const handleStateClose = () => {
        setAnchorElForState(null);
    };
    const handleStoreClick = (event) => {
        setAnchorElForStore(event.currentTarget);
    };
    const handleStoreClose = () => {
        setAnchorElForStore(null);
    };

    const handleSalesClick = (event) => {
        setAnchorElForSales(event.currentTarget);
    };
    const handleSalesClose = () => {
        setAnchorElForSales(null);
    };

    const onSelectBrand = (event) => {
        brandList.forEach(brand => {
            if (event.target.value === brand?.value) {
                // setSelectedBrand({ label: brand?.label, value: event.target.value })
                setAnchorElForBrand(null);
                // dispatch(stockActions.setDefaultBrand({ type: { label: brand?.label, value: event.target.value } }));
                dispatch(brandManagementActions.setSelectedBrand({ type: { label: brand?.label, value: event.target.value } }));
            }
        });
        setSelectedState({ label: '', value: '' })
        setSelectedStore({ label: '', value: '' })
        setSelectedRegion({ label: '', value: '' })
    }
    const onSelectRegion = (event) => {
        regionList.forEach(region => {
            if (event.target.value === region?.value) {
                setSelectedRegion({ label: region?.label, value: event.target.value })
                setAnchorElForRegion(null);
            }
        });
        setSelectedState({ label: '', value: '' })
        setSelectedStore({ label: '', value: '' })
    }
    const onSelectState = (event) => {
        stateList.forEach(state => {
            if (event.target.value === state?.value) {
                setSelectedState({ label: state?.label, value: event.target.value })
                setAnchorElForState(null);
            }
        });
        setSelectedStore({ label: '', value: '' })
    }
    const onSelectStore = (event) => {
        storeList.forEach(store => {
            if (event.target.value === store?.value) {
                setSelectedStore({ label: store?.label, value: event.target.value })
                setAnchorElForStore(null);
            }
        });
    }

    const onSelectSalesYear = (event) => {
        if (event.target.value !== '') {
            dispatch(stockActions.setDefaultYear({ type: { label: event.target.value, value: event.target.value } }));
            dispatch(stockActions.setStartDateDisplay({ type: null }));
            dispatch(stockActions.setEndDateDisplay({ type: null }));
            dispatch(stockActions.setStartDate({ type: null }));
            dispatch(stockActions.setEndDate({ type: null }));
            setDisabledDateRange(true);
            setSelectedCustomSalesYear(null);
            dispatch(stockActions.setCustomDate({ type: null }));
        } else {
            setDisabledDateRange(false);
        }
        if (event.target.value === '') {
            setSelectedCustomSalesYear(null);
            dispatch(stockActions.setCustomDate({ type: null }));
            setSelectedSalesYear({ label: 'Custom', value: event.target.value });
            dispatch(stockActions.setDefaultYear({ type: { label: 'Custom', value: event.target.value } }));
        } else {
            dispatch(stockActions.setDefaultYear({ type: { label: event.target.value, value: event.target.value } }));
        }
        setAnchorElForSales(null);
    }

    const getAllBrand = () => {
        let param = `?user_id=${USER_ID}`
        GetBrandNameList(param, USER_TOKEN).then(response => {
            if (response.data.statusCode === 200) {
                let brands = []
                response.data.data.forEach(element => {
                    let brandObject = {
                        label: element.brand_name,
                        value: element._id
                    }
                    brands.push(brandObject)
                });
                setBrandList(brands);
                if (!defaultBrand.value) {
                    // dispatch(stockActions.setDefaultBrand({ type: { label: brands[0]?.label, value: brands[0]?.value } }));
                    dispatch(brandManagementActions.setSelectedBrand({ type: { label: brands[0]?.label, value: brands[0]?.value } }));
                    // setSelectedBrand({ label: brands[0]?.label, value: brands[0]?.value });
                }
            }
        }).catch(error => {
            if (error.response.status === 401) {
                history.push('/')
            }
            ToastErrorService(error.response.data.message);
        }).finally(() => {
        })
    }

    const checkStoreName = (storeName, storeTradeName) => {
        if (storeTradeName && storeTradeName !== 'null') {
            return storeTradeName
        } else {
            return storeName
        }
    }

    const getRegionStateStore = (brand, region, state) => {
        setLoading(true);
        let param = `?store_region=${region}&store_state=${state}&brand_id=${brand}`
        getStockFilterValue(param, USER_TOKEN).then(response => {
            if (response.data.statusCode === 200) {
                let store = []
                response.data.data.store.forEach(element => {
                    let storeObject = {
                        label: checkStoreName(element.store_name, element.store_trade_name),
                        value: element.store_id
                    }
                    store.push(storeObject)
                });
                setStoreList(store);

                let regions = []
                response.data.data.region.forEach(element => {
                    let regionObj = {
                        label: element.store_region,
                        value: element.store_region
                    }
                    regions.push(regionObj)
                });
                setRegionList(regions);

                let states = []
                response.data.data.state.forEach(element => {
                    let stateObj = {
                        label: element.store_state,
                        value: element.store_state
                    }
                    states.push(stateObj)
                });
                setStateList(states)
            }
        }).catch(error => {
            if (error?.response?.status === 401) {
                history.push('/')
            }
            ToastErrorService(error?.response?.data?.message);
        }).finally(() => {
        })
    }

    const convertDate = (openingDate) => {
        let date = new Date(openingDate);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let dateString = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
        return moment(dateString).format("DD MMM YYYY");
    }

    const convertDateStringToObj = (dateString) => {
        const dateInIST = moment.tz(dateString, 'Asia/Kolkata');
        const finalFormattedDate = new Date(dateInIST.format());
        return finalFormattedDate
    }

    const handleDateRangeSelect = (date) => {
        if (!startDate || (startDate && endDate)) {
            setStartDate(date);
            setEndDate(null);
            setSelectedRange([]);
        } else if (startDate && !endDate && date >= startDate) {
            let endDay = dayjs(date).endOf('day');
            setEndDate(convertDateStringToObj(endDay?.toISOString()));
            setSelectedRange([startDate, convertDateStringToObj(endDay?.toISOString())]);
            setCalendarOpen(false);
            dispatch(stockActions.setStartDateDisplay({ type: startDate }));
            dispatch(stockActions.setEndDateDisplay({ type: convertDateStringToObj(endDay?.toISOString()) }));
            dispatch(stockActions.setStartDate({ type: startDate }));
            dispatch(stockActions.setEndDate({ type: convertDateStringToObj(endDay?.toISOString()) }));
            const storeIds = getStoreIds();
            getDashboardData('', defaultBrand.value, startDate, convertDateStringToObj(endDay?.toISOString()), selectedRegion.value, selectedState.value, storeIds);
        } else if (startDate && !endDate && date < startDate) {
            setStartDate(date);
        }
    };

    const getSalesYearList = () => {
        GetSalesYear(USER_TOKEN).then(response => {
            let salesYear = []
            response.data.data.forEach(element => {
                let salesObj = {
                    label: element,
                    value: element
                }
                if (element !== 'YTD' && element !== 'MTD') {
                    salesYear.push(salesObj)
                }
            });
            salesYear.push({ label: 'Custom', value: '' });
            setSalesYearList(salesYear);
            setDisabledDateRange(true);
            if (!defaultYear.label) {
                dispatch(stockActions.setDefaultYear({ type: { label: salesYear[0]?.label, value: salesYear[0]?.value } }));
                setSelectedSalesYear({ label: salesYear[0]?.label, value: salesYear[0]?.value });
                dispatch(stockActions.setStartDateDisplay({ type: null }));
                dispatch(stockActions.setEndDateDisplay({ type: null }));
                dispatch(stockActions.setStartDate({ type: null }));
                dispatch(stockActions.setEndDate({ type: null }));
                dispatch(stockActions.setCustomDate({ type: null }));
                setSelectedCustomSalesYear(null);
            }
            if (defaultYear.label === 'Custom') {
                setDisabledDateRange(false);
            }
        }).catch(error => {
            if (error.response.status === 401) {
                history.push('/')
            }
            ToastErrorService(error.response.data.message);
        }).finally(() => {

        })
    }

    const onDateSelect = async (value) => {
        setSelectedCustomSalesYear(value);
        dispatch(stockActions.setCustomDate({ type: value }));
        const range = await formatToMonthYear(value);
        const storeIds = getStoreIds();
        getDashboardData(range, defaultBrand.value, '', '', selectedRegion.value, selectedState.value, storeIds);
    }

    const formatToMonthYear = async (dateString) => {
        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            throw new Error('Invalid date');
        }

        const monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];

        const month = monthNames[date.getUTCMonth()];
        const year = date.getUTCFullYear();

        return `${month} ${year}`;
    }

    const getStoreIds = () => {
        if(selectedStore.value !== '') {
            return selectedStore.value
        } else {
            return '';
            // return storeList.map(item => item.value).join(',');
        }
    }


    const onClickSaleTabBtn = (value) => {
        setSaleActiveTabBtn(value);
    }
    const onClickStockTabBtn = (value) => {
        setStockActiveTabBtn(value);
    }

    const onClickSoldCountViewAll = () => {
        setOpenSalesModal(true)
    }
    const onClickCountViewAll = () => {
        setOpenStockModal(true)
    }

    const onClickDownload = () => {
        const storeIds = getStoreIds();
        if (startDate && endDate) {
            downloadReport('', defaultBrand.value, selectedRegion.value, selectedState.value, storeIds, startDate, convertDateStringToObj(dayjs(endDate).endOf('day')?.toISOString()));
        } else {
            downloadReport(selectedMonthYear.replace('-', ' '), defaultBrand.value, selectedRegion.value, selectedState.value, storeIds)
        }
    }

    const valueCheck = (value) => {
        if (value && value !== 'null') {
            return value
        } else {
            return '-'
        }
    }

    const getDashboardData = (range, brand, startdate, enddate, region, state, storeIds) => {
        setLoading(true);
        let param = `?brand_id=${brand}&store_region=${region}&store_state=${state}&store_id=${storeIds}`;
        if (startdate && enddate) {
            param = param + `&from_date=${startdate}&to_date=${enddate}`;
        } else {
            param = param + `&view_range=${range}`;
        }
        GetStockDashboardData(param).then(response => {
            setTotalStockData(response.data.data?.total_stock_data);
            setTotalSoldOutData(response.data.data?.total_soldout_data);
            let table = [];
            response?.data?.data?.fetchStoreWiseStockTable?.map(item => {
                let rowData = {
                    nameStore: item?.store_name,
                    lastUpdated: item?.last_updated_on ? convertDate(item?.last_updated_on) : '-',
                    lastSaleDate: item?.last_sale_date ? convertDate(item?.last_sale_date) : '-',
                    stockQuantity: convertNumbersToReadableFormat(item?.stock_quantity),
                    totalMRP: item?.total_mrp ? `₹${convertNumbersToReadableFormat(item.total_mrp)}` : '0',
                    // MDQ: valueCheck(item?.mdq),
                    MDQ: item?.display_qty,
                    rawMrp: item?.total_mrp ? Number(item.total_mrp) : 0,
                    soldOutCount: convertNumbersToReadableFormat(item?.total_sold_quantity),

                    stockQuantityRaw: item?.stock_quantity,
                    totalMRPRaw: item?.total_mrp ? Number(item.total_mrp) : 0,
                    soldOutCountRaw: item?.total_sold_quantity,
                }
                table.push(rowData);
            })
            setTableData(table)
        }).catch(error => {

        }).finally(() => {
            setLoading(false);
        })
    }

    const getstockDashboardCardData = (range, brand, startdate, enddate, region, state, storeIds) => {
        let param = `?brand_id=${brand}&store_region=${region}&store_state=${state}&store_id=${storeIds}`;
        if (startdate && enddate) {
            param = param + `&from_date=${startdate}&to_date=${enddate}`;
        } else {
            param = param + `&view_range=${range}`;
        }
        GetStockDashboardCardsData(param).then(response => {
            setStockDashCardData(response.data.data?.stockDashboardCards);
        }).catch(error => {
            setStockDashCardData({
                "opening_stock": 0,
                "stock_added": 0,
                "stock_sold": 0,
                "remaining_stock": 0,
                "target_month": ""
            });
        })
    }

    const downloadReport = (range, brand, region, state, storeIds, startdate, enddate) => {
        setLoading(true);
        let param = `?brand_id=${brand}&store_region=${region}&store_state=${state}&store_id=${storeIds}`;
        if (startdate && enddate) {
            param = param + `&from_date=${startdate}&to_date=${enddate}`;
        } else {
            param = param + `&view_range=${range}`;
        }
        DownlaodStockReport(param, USER_TOKEN).then(response => {
            const responseInUnit = new Uint8Array(response.data.buffer.data);
            const blob = new Blob([responseInUnit], { type: 'application/octet-stream' });
            saveAs(blob, response.data.filename);
            if (response?.data?.buffer?.statusCode === 400) {
                ToastErrorService(response?.data?.buffer?.message);
            } else {
                ToastSuccessService('Report downloaded successfully.');
            }
        }).catch(error => {
            ToastErrorService(error?.response?.data?.message)
        }).finally(() => {
            setLoading(false);
        })
    }

    const onGridReady = (params) => {
        gridRef.current = params.api;
        gridRef.current.sizeColumnsToFit();
    };

    const onClickClear = (filter) => {
        if (filter === 'store') {
            setSelectedStore({ label: '', value: '' })
        } else if (filter === 'state') {
            setSelectedState({ label: '', value: '' })
        } else {
            setSelectedRegion({ label: '', value: '' })
        }
    }

    const createBrandWiseTotalRow = () => {
        //Brand Wise Sales

        let totalRecords = 0;
        let totalMrpValue = 0;
        let totalStockQuantity = 0;
        let totalMdq = 0;
        let totalSoldOutQuantity = 0;
        tableData.forEach((item, index) => {
            totalMrpValue = totalMrpValue + Number(item.rawMrp);
            totalStockQuantity = totalStockQuantity + (Number(item.stockQuantityRaw) || 0);
            totalMdq = totalMdq + Number(item.MDQ);
            totalRecords = index + 1;
            totalSoldOutQuantity = totalSoldOutQuantity + Number(item?.soldOutCountRaw);
        })

        let averageMdq = totalMdq > 0 ? (Number(totalMdq) / Number(totalRecords)).toFixed(2) : 0;
        return [{
            nameStore: 'Total',
            // stockAsOn: `-`,
            lastUpdated: `-`,
            lastSaleDate: `-`,
            totalMRP: `₹${totalMrpValue.toLocaleString('en-IN')}`,
            stockQuantity: convertNumbersToReadableFormat(totalStockQuantity),
            MDQ: `${Number(Math.round(Number(averageMdq))).toLocaleString('en-IN')}`,
            soldOutCount: convertNumbersToReadableFormat(Number(totalSoldOutQuantity)),
        }];
    }

    const onClickBrokenSize = () => {
        history.push('/app/brokenSize');
        dispatch(userAuthActions.setIsBackBtnActive({ type: true }));
    }

    const handleDetailedModal = (heading, data) => {
        setOpenDetailedModal(true);

        if (!Array.isArray(data?.stockList)) {
            setDetailedModalData({
                heading,
                data: []
            });
            return;
        }

        const newList = data?.stockList.map(item => ({
            storeName: item?.store_details?.store_trade_name,
            barcode: item?.barcode,
            category: item?.category_division,
            season: item?.season,
            color: item?.color,
            size: item?.size,
            stockQuantity: item?.remaining_stock,
            soldQuantity: item?.stock_sold,
        }));

        setDetailedModalData({
            heading,
            data: newList
        });
    };

    const createTotalRowDetailedStockList = () => {
        
        let totalStockQuantity = 0;
        let totalSoldQuantity = 0;
        
        detailedModalData?.data.forEach((item, index) => {
            totalStockQuantity = totalStockQuantity + Number(item.stockQuantity);
            totalSoldQuantity = totalSoldQuantity + Number(item.soldQuantity);
        })

        return [{
            nameStore: 'Total',
            stockQuantity: totalStockQuantity,
            soldQuantity: totalSoldQuantity,
        }];

    }

    const onMonthSelect = (value) => {
        setSelectedMonthYear(convertDateIntoMonth(value));
        dispatch(stockActions.setDefaultMonthYear({ type: convertDateIntoMonth(value) }));
    }

    const convertNumbersToReadableFormat = (value) => {
        if (!value || value === null || value === undefined) return 0;
        return Number(value).toLocaleString('en-IN');
    }


    return (
        <div className='dashboard-container'>
            <div className='d-flex justify-content-between filter-cont fixed-filter'>
                <div className='d-flex align-items-center first-filter'>
                    <button className='goToMasterBtn me-3' onClick={onClickGotoReports}>Go to Reports</button>
                    {/* brand filter */}
                    <div className='position-relative min-w-150'>
                        <button className='d-flex textColorGray notoSansFont statusFilter cursorPointer align-items-center justify-content-between me-3'
                            onClick={handleBrandClick}>
                            <p className='text-truncate' title={defaultBrand.label}>{defaultBrand?.label}</p>
                            <img className={`${openBrandFilter ? 'transform180 pe-2' : 'ps-2'}`} src={dropDownIcon} alt="" />
                        </button>
                        <CustomFilterSearchDropdown data={brandList} handleClose={handleBrandClose} open={openBrandFilter} anchorEl={anchorElForBrand}
                            onChange={onSelectBrand} selectedValue={defaultBrand?.value} category={'Brand'}
                            dropSearchValue={dropSearchValue.brand} handleSearchChange={(e) => handleSearchChange(e, 'brand')} setdropSearchValue={setdropSearchValue} />
                    </div>
                    {/* region filter  */}
                    <div className='position-relative min-w-150'>
                        <button className='d-flex textColorGray notoSansFont statusFilter cursorPointer align-items-center justify-content-between me-3'
                            onClick={handleRegionClick}>
                            <p className='text-truncate' title={selectedRegion.label}>{selectedRegion?.label === '' ? 'Select Region' : selectedRegion?.label}</p>
                            <img className={`${openRegionFilter ? 'transform180 pe-2' : 'ps-2'}`} src={dropDownIcon} alt="" />
                        </button>
                        <CustomFilterSearchDropdown onClickClear={() => onClickClear('region')} data={regionList} handleClose={handleRegionClose} open={openRegionFilter} anchorEl={anchorElForRegion}
                            onChange={onSelectRegion} selectedValue={selectedRegion?.value} category={'Region'}
                            dropSearchValue={dropSearchValue.region} handleSearchChange={(e) => handleSearchChange(e, 'region')} setdropSearchValue={setdropSearchValue} />
                    </div>
                    {/* state filter  */}
                    <div className='position-relative min-w-150'>
                        <button className='d-flex textColorGray notoSansFont statusFilter cursorPointer align-items-center justify-content-between me-3'
                            onClick={handleStateClick}>
                            <p className='text-truncate' title={selectedState.label}>{selectedState?.label === '' ? 'Select State' : selectedState?.label}</p>
                            <img className={`${openStateFilter ? 'transform180 pe-2' : 'ps-2'}`} src={dropDownIcon} alt="" />
                        </button>
                        <CustomFilterSearchDropdown onClickClear={() => onClickClear('state')} data={stateList} handleClose={handleStateClose} open={openStateFilter} anchorEl={anchorElForState}
                            onChange={onSelectState} selectedValue={selectedState?.value} category={'Brand'}
                            dropSearchValue={dropSearchValue.state} handleSearchChange={(e) => handleSearchChange(e, 'state')} setdropSearchValue={setdropSearchValue} />
                    </div>
                    {/* store filter  */}
                    <div className='position-relative min-w-150'>
                        <button className='d-flex textColorGray notoSansFont statusFilter cursorPointer align-items-center justify-content-between me-3'
                            onClick={handleStoreClick}>
                            <p className='text-truncate' title={selectedStore.label}>{selectedStore?.label === '' ? 'Select Store' : selectedStore?.label}</p>
                            <img className={`${openStoreFilter ? 'transform180 pe-2' : 'ps-2'}`} src={dropDownIcon} alt="" />
                        </button>
                        <CustomFilterSearchDropdown onClickClear={() => onClickClear('store')} data={storeList} handleClose={handleStoreClose} open={openStoreFilter} anchorEl={anchorElForStore}
                            onChange={onSelectStore} selectedValue={selectedStore?.value} category={'Brand'}
                            dropSearchValue={dropSearchValue.store} handleSearchChange={(e) => handleSearchChange(e, 'store')} setdropSearchValue={setdropSearchValue} />
                    </div>
                </div>
                <div className='d-flex align-items-center'>
                    {/* <div className='position-relative min-w-150'>
                        <button className='d-flex textColorGray notoSansFont statusFilter cursorPointer align-items-center justify-content-between me-3'
                            onClick={handleSalesClick}>
                            <p className='text-truncate' title={defaultYear.label}>{defaultYear?.label}</p>
                            <img className={`${openSalesYearFilter ? 'transform180 pe-2' : 'ps-2'}`} src={dropDownIcon} alt="" />
                        </button>
                        <CustomFilterDropDown data={salesYearList} handleClose={handleSalesClose} open={openSalesYearFilter} anchorEl={anchorElForSales}
                            onChange={onSelectSalesYear} selectedValue={defaultYear?.value} category={'Category'} />
                    </div> */}
                    <CustomMonthYearPicker maxDateRange={dayjs()} disabled={false} value={selectedMonthYear} defaultValue={dayjs(selectedMonthYear)} onDateChange={(newValue) => onMonthSelect(newValue)} required customClass={'customeClass'} />
                    
                    {/* <div className='position-relative'> */}
                        {/* <button className={`d-flex dateRangeFilter cursorPointer align-items-center ${!disabledDateRange ? 'justify-content-between' : ''}`} disabled={disabledDateRange}
                            onClick={openCalendar} >
                            <img src={CalendarIcon} alt="" />
                            {(startDateDisplay && endDateDisplay) ? <div>{`${convertDate(startDateDisplay)} - ${convertDate(endDateDisplay)}`}</div> : <div className='text-center w-100'>Select Date</div>}
                        </button> */}
                        {/* <div className=''>
                            <CustomMonthYearPicker disabled={defaultYear.label !== 'Custom'} selectedDate={selectedCustomSalesYear} defaultValue={selectedCustomSalesYear} onDateChange={(newValue) => onDateSelect(newValue)} maxDateRange={dayjs()} required customClass={'customeClass'} label={'Select Month'} /> */}
                            {/* <CustomDateRangePicker restrictFutureDates={true} startDate={startDate} endDate={endDate} calendarOpen={calendarOpen} selectedRange={selectedRange} handleSelect={handleDateRangeSelect}
                                closeOnOutSide={() => setCalendarOpen(false)} /> */}
                        {/* </div> */}
                    {/* </div> */}
                </div>
            </div>
            <div className='stock-dash-container mt-4 pt-3'>
                <div className='stock-card'>
                    <div className='img-class'>
                        {/* <img src={DiscountValueIcon} alt="" /> */}
                    </div>
                    <div>
                        <div className='heading'>Opening Stock</div>
                        <div className='stock-value'>{convertNumbersToReadableFormat(stockDashCardData?.opening_stock) || 0}
                        </div>
                    </div>
                </div>
                <div className='stock-card'>
                    <div className='img-class'>
                        {/* <img src={DiscountValueIcon} alt="" /> */}
                    </div>
                    <div>
                        <div className='heading'>Stock Added</div>
                        <div className='stock-value'>{convertNumbersToReadableFormat(stockDashCardData?.stock_added) || 0}
                        </div>
                    </div>
                </div>
                <div className='stock-card'>
                    <div className='img-class'>
                        {/* <img src={DiscountValueIcon} alt="" /> */}
                    </div>
                    <div>
                        <div className='heading'>Stock Sold</div>
                        <div className='stock-value'>{convertNumbersToReadableFormat(stockDashCardData?.stock_sold) || 0}
                        </div>
                    </div>
                </div>
                <div className='stock-card'>
                    <div className='img-class'>
                        {/* <img src={DiscountValueIcon} alt="" /> */}
                    </div>
                    <div>
                        <div className='heading'>Remaining Stock</div>
                        <div className='stock-value'>{convertNumbersToReadableFormat(stockDashCardData?.remaining_stock) || 0}
                        </div>
                    </div>
                </div>
            </div> 
            <div>
                <div className='count-conatiner'>
                    <div className='count-card'>
                        <div>
                            <div className='fontSize18 montSerratFont textColorBlack'>Total Stock Count</div>
                            <div className='fontSize24 notoSansFont fontSemiBold text24 textColor333 pt-2'>{convertNumbersToReadableFormat(totalStockData?.totalStockCount) || 0}</div>
                            <div className='cat-season-btn-cont'>
                                <button onClick={() => onClickStockTabBtn(1)} className={`${stockActiveTabBtn === 1 ? 'active-tab-btn-bg' : 'tab-btn-bg'}`}>Category</button>
                                <button onClick={() => onClickStockTabBtn(2)} className={`${stockActiveTabBtn === 2 ? 'active-tab-btn-bg' : 'tab-btn-bg'}`}>Season</button>
                            </div>
                        </div> 
                        <div className='scrolling-height'>
                            {(stockActiveTabBtn === 1 ? totalStockData?.stockCategoryWisekCount : totalStockData?.stockSeasonWiseCount)?.map(item => (<div className='card-data' key={item?.category_group || item?.season} > {/** onClick={()=>handleDetailedModal(stockActiveTabBtn === 1 ? 'Category Wise Stock List' : 'Season Wise Stock List', item)} */}
                                <div className='d-flex align-items-center'>
                                    <div className='dot-div me-2'></div>
                                    {stockActiveTabBtn === 1 && <div className='item-name'>{(item?.category_group !== 'null' && item?.category_group !== '') ? item.category_group : 'Others'}</div>}
                                    {stockActiveTabBtn === 2 && <div className='item-name'>{item?.season !== 'null' ? item?.season : 'Others'}</div>}
                                </div>
                                <div className='counts'>{convertNumbersToReadableFormat(item?.totalQuantity) || 0}</div>
                            </div>))}
                        </div>
                        {/* {stockActiveTabBtn === 1 && <div className='notoSansFont d-flex justify-content-end'>
                            <button onClick={onClickCountViewAll} className='view-all-btn'>view all</button>
                        </div>} */}
                    </div>
                    <div className='count-card'>
                        <div>
                            <div className='fontSize18 montSerratFont textColorBlack'>Total Sold Out Count</div>
                            <div className='fontSize24 notoSansFont fontSemiBold text24 textColor333 pt-2'>{convertNumbersToReadableFormat(totalSoldOutData?.totalSalesCount) || 0}</div>
                            <div className='cat-season-btn-cont'>
                                <button onClick={() => onClickSaleTabBtn(1)} className={`${saleActiveTabBtn === 1 ? 'active-tab-btn-bg' : 'tab-btn-bg'}`}>Category</button>
                                <button onClick={() => onClickSaleTabBtn(2)} className={`${saleActiveTabBtn === 2 ? 'active-tab-btn-bg' : 'tab-btn-bg'}`}>Season</button>
                            </div>
                        </div> 
                        <div className='scrolling-height'>
                            {(saleActiveTabBtn === 1 ? totalSoldOutData?.totalCategoryWiseSalesCount : totalSoldOutData?.salesSeasonWiseCount)?.map((item) => (<div className='card-data' key={item?.category_group || item?.season} > {/** onClick={()=>handleDetailedModal(saleActiveTabBtn === 1 ? 'Category Wise Sold Stock List' : 'Season Wise Sold Stock List', item)} */}
                                <div className='d-flex align-items-center'>
                                    <div className='dot-div me-2'></div>
                                    {saleActiveTabBtn === 1 && <div className='item-name'>{(item?.category_group !== 'null' && item?.category_group !== '') ? item.category_group : 'Others'}</div>}
                                    {saleActiveTabBtn === 2 && <div className='item-name'>{item?.season !== 'null' ? item?.season : 'Others'}</div>}
                                </div>
                                <div className='counts'>{convertNumbersToReadableFormat(item?.totalQuantity) || 0}</div>
                            </div>))}
                        </div>
                        {/* {saleActiveTabBtn === 1 && <div className='notoSansFont d-flex justify-content-end'>
                            <button onClick={onClickSoldCountViewAll} className='view-all-btn'>view all</button>
                        </div>} */}
                    </div>
                </div>
            </div>
            <div className='stock-details'>
                <div className='d-flex justify-content-between'>
                    <div className='fontSize18 montSerratFont textColorBlack'>{defaultBrand?.label} Stock Details</div>
                    <div className='d-flex'>
                        <div className='me-2'>
                            <CustomBlueButton onClick={onClickBrokenSize} title={'Broken Size'} />
                        </div>
                        <button className='download-btn' onClick={onClickDownload}>
                            <img src={DownloadIcon} width={24} height={24} alt="" />
                        </button>
                    </div>

                </div>
                <div className='paddingTop16 reports'>
                    <CustomTableWithFilter layoutDom={tableData?.length > 7 ? 'normal' : 'autoHeight'} totalRow={createBrandWiseTotalRow} isContentLeftRightFixed={false} column={stockDashboardTableHeader} tableRowData={tableData} onGridReady={onGridReady} />
                </div>
            </div>

            {/* Stock Modal */}
            <CustomModal open={openStockModal} style={modalStyle} handleClose={null}
                content={<div>
                    <div className='d-flex align-items-center'>
                        <div className='montSerratFont fontSize18 textColorBlack position-relative d-flex w-100'>
                            <div>Total Stock Count</div>
                            <button className='modalCloseIconPlacement cursorPointer' onClick={() => setOpenStockModal(false)}>
                                <img src={CloseIcon} alt="" />
                            </button>
                        </div>
                    </div>
                    <div className='dataInsideModal customScroll'>
                        {(totalStockData?.stockCategoryWisekCount)?.map(item => (<div className='card-data' key={item?.category_group}>
                            <div className='d-flex align-items-center'>
                                <div className='dot-div me-2'></div>
                                <div className='item-name'>{(item?.category_group !== 'null' ? item.category_group : 'Others')}</div>
                            </div>
                            <div className='counts'>{item?.totalQuantity}</div>
                        </div>))}
                    </div>
                </div>} />
            {/* Sales Modal */}
            <CustomModal open={openSalesModal} style={modalStyle} handleClose={null}
                content={<div>
                    <div className='d-flex align-items-center'>
                        <div className='montSerratFont fontSize18 textColorBlack position-relative d-flex w-100'>
                            <div>Total Sold Out Count</div>
                            <button className='modalCloseIconPlacement cursorPointer' onClick={() => setOpenSalesModal(false)}>
                                <img src={CloseIcon} alt="" />
                            </button>
                        </div>
                    </div>
                    <div className='dataInsideModal customScroll'>
                        {(totalSoldOutData?.totalCategoryWiseSalesCount)?.map(item => (<div className='card-data' key={item?.category_group}>
                            <div className='d-flex align-items-center'>
                                <div className='dot-div me-2'></div>
                                <div className='item-name'>{(item?.category_group !== 'null' ? item.category_group : 'Others')}</div>
                            </div>
                            <div className='counts'>{item?.totalQuantity}</div>
                        </div>))}
                    </div>
                </div>} />

            {/* Stock Detailed Modal */}
            <CustomModal open={openDetailedModal} style={modalStyle} handleClose={null}
                content={
                <div>
                    <div className='d-flex align-items-center'>
                        <div className='montSerratFont fontSize18 textColorBlack position-relative d-flex w-100'>
                            <div>{detailedModalData?.heading}</div>
                            <button className='modalCloseIconPlacement cursorPointer' onClick={() => setOpenDetailedModal(false)}>
                                <img src={CloseIcon} alt="" />
                            </button>
                        </div>
                    </div>
                    <div className='paddingTop16 reports'>
                        <CustomTableWithFilter layoutDom={detailedModalData?.data?.length > 7 ? 'normal' : 'autoHeight'} totalRow={createTotalRowDetailedStockList} isContentLeftRightFixed={false} column={stockDashboardDetailedTableHeader} tableRowData={detailedModalData?.data} onGridReady={onGridReady} />
                    </div>
                </div>} />

            {/* Loader */}
            {loading && <Loader />}
        </div>
    )
}

export default StockDashboard